<template>
  <camoodoo-page>
    <camoodoo-title-section></camoodoo-title-section>
    <remote-control-section class="section-bg-dark"></remote-control-section>
    <liveview-section class="section-bg-light"></liveview-section>
    <interval-section class="section-bg-dark"></interval-section>
    <histogram-section class="section-bg-light"></histogram-section>
    <bulb-section class="section-bg-dark"></bulb-section>
    <ev-calculator-section class="section-bg-light"></ev-calculator-section>
    <bracketing-section class="section-bg-dark"></bracketing-section>
    <browse-section class="section-bg-light"></browse-section>
  </camoodoo-page>
</template>

<script>
import CamoodooPage from "@/components/CamoodooPage.vue";
import RemoteControlSection from "@/sections/home/RemoteControlSection.vue";
import BulbSection from "@/sections/home/BulbSection.vue";
import EvCalculatorSection from "@/sections/home/EvCalculatorSection.vue";
import HistogramSection from "@/sections/home/HistogramSection.vue";
import IntervalSection from "@/sections/home/IntervalSection.vue";
import BracketingSection from "@/sections/home/BracketingSection.vue";
import BrowseSection from "@/sections/home/BrowseSection.vue";
import LiveviewSection from "@/sections/home/LiveviewSection.vue";
import CamoodooTitleSection from "@/sections/home/CamoodooTitleSection.vue";

export default {
  components: {
    CamoodooPage,
    RemoteControlSection,
    BulbSection,
    EvCalculatorSection,
    IntervalSection,
    BrowseSection,
    CamoodooTitleSection,
    BracketingSection,
    HistogramSection,
    LiveviewSection,
  },
};
</script>

<style lang="scss" scoped></style>
